import { render, staticRenderFns } from "./DeptRecordsList.vue?vue&type=template&id=4d3c8b62&scoped=true"
import script from "./DeptRecordsList.vue?vue&type=script&lang=js"
export * from "./DeptRecordsList.vue?vue&type=script&lang=js"
import style0 from "./DeptRecordsList.vue?vue&type=style&index=0&id=4d3c8b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c8b62",
  null
  
)

export default component.exports